import React, {useEffect, useState} from 'react';
import axios from 'axios';
import moment from "moment-timezone";
import config from '../config';
import ErrorIcon from '../assets/SVG/icons/error-icon.svg';
import '../styles/qrcodescanpage.css';
import CovidResultGradient from '../components/CovidResultGradient';

export default function QRCodeScanPageV2() {
    const [name, setName] = useState("");
    const [test_date, setTestDate] = useState("");
    const [test_time, setTestTime] = useState("");
    const [isCovid, setIsCovid] = useState(null);
    const [pictures, setPictures] = useState([new Image(), new Image(), new Image(), new Image()]);
    const [isTestValid, setIsTestValid] = useState(true);
    const [isLoading, setIsLoading] = useState(true);
    const [message, setMessage] = useState("");
    const [timezone, setTimezone] = useState("UTC");
    const [probability, setProbability] = useState(0);
    const [threshold, setThreshold] = useState(null);
    const [questionnaire, setQuestionnaire] = useState({});

    useEffect(() => {
        getResult();
    }, []);

    const getResult = () => {
        axios.get(config.backend_url + window.location.pathname)
          .then((response) => {
              let result = response.data.result;
              let test_date = result.test_date;

              //checking the test is neg or pos
              let isCovid = true;
              if (result.covid_status === "Negative") {
                  isCovid = false;
              }

              //checking the test is valid or not
              let test_time = new Date(result.test_date).getTime();
              let currentTime = new Date().getTime();
              let isTestValid = true;

              if (test_time + config.test_expire_time < currentTime) {
                  isTestValid = false;
              }

              //converting byte data array to image object url
              let pictures = [];
              for (let i = 0; i < result.pictures.length; i++) {
                  const picture = result.pictures[i];
                  const arrayBufferView = new Uint8Array(picture.data);
                  const blob = new Blob([arrayBufferView], {type: "image/jpeg"});
                  const urlCreator = window.URL || window.webkitURL;
                  const imageUrl = urlCreator.createObjectURL(blob);
                  pictures.push(imageUrl);
              }

              setName(result.name);
              setTestDate(moment(test_date).tz(result?.timezone || "UTC").format('YYYY-MM-DD'));
              setTestTime(moment(test_date).tz(result?.timezone || "UTC").format('hh:mm A'));
              setIsCovid(isCovid);
              setPictures(pictures);
              setIsTestValid(isTestValid);
              setIsLoading(false);
              setMessage(result.quality_message);
              setTimezone(result.timezone || "UTC");
              setProbability(result.result);
              setThreshold(result.threshold);
              setQuestionnaire(result.questionnaire);
          })
          .catch((err) => {
              console.error(err.response);
              setIsLoading(false);
          })
    }

    return (
      <div className="qrcode-test" data-testid="qrcode-test">
          {isLoading && (<div id="test-loading"/>)}
          <div className="container">
              <div className='main'>
                  <div className="card">
                      <div className="card-body">

                          {!isTestValid && (
                            <p className="error-text text-orange text-bold font-size-10">
                                <img src={ErrorIcon} alt="err"/> Caution: This test was done more than 24 hours ago.
                            </p>
                          )}

                          {isCovid !== null && (
                            <div className='profile-photos'>
                                {
                                    pictures.map((pic, index) => (
                                      <img key={index} src={pic} className="profile" alt='profile'/>
                                    ))
                                }
                            </div>
                          )}

                          {isCovid !== null && (
                            <div>
                                <p className="text-bold font-size-18 mt-1">{name}</p>
                                <p>Date: <span className="text-bold">{test_date}</span> <br/>
                                    Test Time: <span className="text-bold">{test_time}</span>
                                </p>
                            </div>
                          )}

                          <p className="mt-3"><span className="text-bold text-cyan font-size-18">COVID-19</span></p>

                          {isCovid === null ? <> Record Not Found</> : (
                            <CovidResultGradient
                              threshold={threshold}
                              probability={probability}
                              isCovid={isCovid}
                              questionnaire={questionnaire}
                              isTransparent
                            />
                          )}

                          {message && (
                            <div className='error'>
                                <img src={ErrorIcon} alt="error icon"/>
                                <span className='fpError' data-testid="fpMessage">{message}</span>
                            </div>
                          )}
                      </div>
                  </div>
              </div>
          </div>
      </div>
    )
}